import styled from '@emotion/styled';
import { mediaTablet } from '../styles/breakpoints';

export default styled.h1`
  font-family: 'Zilla Slab';
  font-style: normal;
  font-weight: 500;
  font-size: 58px;

  line-height: 1;

  ${mediaTablet} {
    font-size: 37px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/H1/H1.js